// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__8OxHn","tab":"Profile_tab__u24GY","loaderContainer":"Profile_loaderContainer__HU36H"};